import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from './../service/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.response.intFKIDProfile === 1) {
      const url = state.url || '';
      const restrictedPaths = [
        'socios-parkit',
        'users',
        'parkingArea',
        'enclosures',
        'create-locality',
        'parking-zone',
        'eventType',
        'discount-code',
        'disclaimers',
        'generate-qr',
        'qrabonados',
        'list-parking-pen'
      ];
      const isRestricted = restrictedPaths.some(path => url.includes(path));
      if (isRestricted && Number(currentUser.response.intIDUsuario) !== 1) {
        this.router.navigate(['/home']);
        return false;
      }
      return true;
    }
    this.router.navigate(['/home'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
